import { render, staticRenderFns } from "./profile-list.vue?vue&type=template&id=4bd6440c&scoped=true&"
import script from "./profile-list.vue?vue&type=script&lang=ts&"
export * from "./profile-list.vue?vue&type=script&lang=ts&"
import style0 from "./profile-list.vue?vue&type=style&index=0&id=4bd6440c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd6440c",
  null
  
)

export default component.exports